import { render, staticRenderFns } from "./TipTapToolbarButton.vue?vue&type=template&id=eb439d42&scoped=true"
import script from "./TipTapToolbarButton.vue?vue&type=script&lang=js"
export * from "./TipTapToolbarButton.vue?vue&type=script&lang=js"
import style0 from "./TipTapToolbarButton.vue?vue&type=style&index=0&id=eb439d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb439d42",
  null
  
)

export default component.exports